export default __webpack_public_path__ + "static/media/webDevelopment.48510cdb.png";